var render = function render(){var _vm=this,_c=_vm._self._c;return _c('aside',{class:[
    _vm.show && 'opened',
    (_vm.opened === 'project' || _vm.opened === 'external') && 'able-scroll',
    ((_vm.opened === 'project' || _vm.opened === 'create-project' || _vm.opened === 'delete-project' ) && _vm.opened !== 'external') && 'dash'
  ]},[_c('div',{ref:"content",staticClass:"content"},[_c('div',{staticClass:"close",on:{"click":_vm.handleModal}},[_vm._m(0)]),_vm._t("default")],2)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('button',[_c('img',{attrs:{"src":"/images/modal/close.svg"}})])
}]

export { render, staticRenderFns }